import { useFormik } from 'formik';
import { Hooks } from 'providers';
import { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import * as Yup from 'yup';

import { Organization } from 'providers/Organization';
import { useOuterClick } from 'providers/OutsideClick';

import { HIT_ADD_NODE_EMPLOYEE } from 'redux/actions/organization';

function ModalForm(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    pid__,
    modalAddEmployee: modal,
    setModalAddEmployee: setModal,
    setPid__,
  } = useContext(Organization);
  const { setModal: setModal__, modal: modal__ } = useContext(Hooks);
  const {
    job_, loading, listStructureRaw, list_employee,
  } = useSelector(
    (state) => ({
      job_: state.organization.list_job.map((val) => ({
        value: val.job_level_id,
        label: val.name,
      })),
      listStructureRaw: state.organization.structure,
      list_employee: state.organization.employee_chart,
      loading: state?.loading?.trigger,
    }),
  );

  const list_structure = useMemo(
    () => listStructureRaw?.map((val) => ({
      value: val.organization_id,
      label: val.name,
    })),
    [listStructureRaw],
  );

  const innerRef = useOuterClick((e) => {
    if (e.srcElement.id === 'createNodesEmployee') {
      setModal(false);
    }
  });

  const formik = useFormik({
    initialValues: {
      nik: '',
      nama: '',
      organization_id: null,
    },
    validationSchema: Yup.object().shape({
      nama: Yup.string()
        .typeError('Must be string')
        .required(t('org.employee.form.field_cannot_empty')),
      nik: Yup.string()
        .typeError('Must be number')
        .required(t('org.employee.form.field_cannot_empty')),
      organization_id: Yup.string()
        .typeError('Must be string')
        .required(t('org.employee.form.field_cannot_empty')),
    }),
    onSubmit: async (values) => {
      await dispatch({
        type: HIT_ADD_NODE_EMPLOYEE,
        payload: {
          datas: values,
          board_id: localStorage.getItem('board_id'),
        },
      });
      setModal(false);
      setModal__(false);
      setPid__('random');
      formik.setValues({});
    },
  });

  useEffect(() => { }, [loading]);

  useEffect(() => {
    formik.resetForm();
  }, [modal]);

  return (
    <div
      id="createNodesEmployee"
      className={`modal fade rModal ${modal && 'show'}`}
      style={{
        display: modal ? 'block !important' : 'none !important',
        width: 'fit-content',
        height: 'fit-content',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div
        id="createNodesEmployee"
        className="org-chart org-chart w-100 h-100 d-flex my-auto mx-auto"
      >
        <div className="org-chart_wrap my-auto mx-auto">
          <form action="" onSubmit={() => formik.handleSubmit()}>
            <h3>{props.title}</h3>
            <label>{t('org.structure_view.personel.form.name')}</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="nama"
              value={formik.values.nama}
              placeholder={t('org.structure_view.personel.form.p_name')}
              onChange={formik.handleChange}
            />
            {formik.touched.nama && formik.errors.nama ? (
              <>
                <span className="error">{formik.errors.nama}</span>
                <br />
              </>
            ) : null}
            <label>{t('org.structure_view.personel.form.nik')}</label>
            <input
              className="form-control form-control-md mb-2 "
              type="text"
              name="nik"
              id="nik"
              value={formik.values.nik}
              onChange={formik.handleChange}
              placeholder={t('org.structure_view.personel.form.p_nik')}
            />
            {formik.touched.nik && formik.errors.nik ? (
              <>
                <span className="error">{formik.errors.nik}</span>
                <br />
              </>
            ) : null}
            <label>{t('org.structure_view.personel.form.organization')}</label>
            <Select
              options={list_structure}
              id="organization_id"
              name="organization_id"
              onChange={(e) => formik.setFieldValue('organization_id', e.value)}
              value={list_structure?.filter(
                (item) => item?.value === formik?.values?.organization_id,
              )}
              placeholder={t('org.index_view.job_wizard.form.select_parent')}
            />
            {formik.touched.organization_id && formik.errors.organization_id ? (
              <>
                <span className="error">{formik.errors.organization_id}</span>
                <br />
              </>
            ) : null}
            <div className="btn-submit d-flex justify-content-center align-items-center float-right mt-4">
              <button
                className="add"
                type="button"
                onClick={(e) => {
                  formik.handleSubmit(e);
                }}
              >
                {t('board.submit')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModalForm;
